export default __webpack_public_path__ + "assets/docx.d99aeeb833c328dc360bb2dc1d99126f.png";